import _ from "lodash";
import { fetchApi } from "../../utils";

// const mapField = item => {
//   let i = 0;
//   return {
//     ...item,
//     services: _.compact(
//       _.map(item, (value, key) => {
//         if (_.includes(key, "media_icon_") && _.endsWith(key, "data")) {
//           i++;
//           return {
//             icon: _.get(value, "full_file_path"),
//             title: _.get(item, `title_${i}`),
//             detail: _.get(item, `detail_${i}`)
//           };
//         }
//         return null;
//       })
//     )
//   };
// };

const getPageserviceApi = () => {
  return fetchApi("page/service").then(res => _.get(res, "data"));
};

export { getPageserviceApi };



// WEBPACK FOOTER //
// ./src/services/page/service.js